var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowProgress = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.031 22.7709C11.324 23.0521 11.324 23.5079 11.031 23.7891C10.7381 24.0703 10.2632 24.0703 9.97027 23.7891L4.71969 18.7491C4.57903 18.6141 4.5 18.431 4.5 18.24C4.5 18.049 4.57903 17.8659 4.7197 17.7309L9.97027 12.6909C10.2632 12.4097 10.7381 12.4097 11.0311 12.6909C11.324 12.9721 11.324 13.428 11.031 13.7091L7.06095 17.52H17.7495C18.6115 17.52 19.4383 17.1913 20.0478 16.6062C20.6574 16.0211 20.9998 15.2275 20.9998 14.4V12.72C20.9998 12.3224 21.3357 12 21.7499 12C22.1642 12 22.5 12.3224 22.5 12.72V14.4C22.5 15.6094 21.9995 16.7692 21.1086 17.6244C20.2177 18.4796 19.0094 18.96 17.7495 18.96H7.06094L11.031 22.7709Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.969 1.22912C12.676 0.947939 12.676 0.492061 12.969 0.210883C13.2619 -0.0702944 13.7368 -0.0702944 14.0297 0.210883L19.2803 5.25088C19.421 5.38591 19.5 5.56905 19.5 5.76C19.5 5.95096 19.421 6.13409 19.2803 6.26912L14.0297 11.3091C13.7368 11.5903 13.2619 11.5903 12.9689 11.3091C12.676 11.0279 12.676 10.572 12.969 10.2909L16.939 6.48H6.25052C5.38847 6.48 4.56173 6.80871 3.95217 7.39383C3.34261 7.97894 3.00017 8.77252 3.00017 9.6V11.28C3.00017 11.6776 2.66434 12 2.25008 12C1.83582 12 1.5 11.6776 1.5 11.28V9.6C1.5 8.39061 2.0005 7.23076 2.89139 6.37559C3.78229 5.52043 4.99061 5.04 6.25052 5.04H16.9391L12.969 1.22912Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowProgress);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-progress.7899995037e81a9453653e5cbd467e95.svg";